import { Col, Image, Modal, Row } from 'antd';
import React from 'react';

const CandidateReviewModal = ({
  openCandidateReviewMOdal,
  setOpenCandidateReviewModal,
  candidateResponseData,
  setcandidateResponseData,
}) => {
  console.log(candidateResponseData, 'dldmdlmd');
  const handleCancel=()=>{
    setOpenCandidateReviewModal(false)
    setcandidateResponseData(null)
  }
  return (
    <Modal
      title='Candidate Response'
      open={openCandidateReviewMOdal}
      width={'75%'}
    //   closeIcon={null}
      footer={null}
      onCancel={handleCancel}

      className="review-modal"
    >
      <div className='overflow-auto'>
        {candidateResponseData?.map((val, index) => {
          return (
            <div>
              <span className='fw-medium fs-5 text-capitalize'> section:  {val?.section}</span>
              {val?.questions?.map((item, indexques) => {
                return (
                  <Row className=' container-lg m-lg-4'>
                    <Col lg={15} sm={24} md={20}>
                      <div className='fw-semibold fs-6 text-color-custom '>
                        Question {indexques + 1} 
                      </div>
                     
                      <div className="m-lg-2">
                      <div className='fw-medium fs-4 mb-3'>{item?.title}</div>
                       <Image
                          src={item?.imageUrl}
                          preview={true}
                          width={200}
                          className="question-image mb-3"
                        />
                      <Row gutter={[15, 16]}>
                        {item?.options?.map((option, optionINdex) => {
                          return (
                            <Col
                              className={`border p-2 fw-bold text-muted ${
                                option?.is_answer == true &&
                                item?.candidateAnswer?.includes(optionINdex)
                                  ? 'bg-success'
                                  : option?.is_answer == false &&
                                    item?.candidateAnswer?.includes(optionINdex)
                                  ? 'bg-danger'
                                  : ''
                              }`}
                              span={24}
                            >
                              {option?.text}
                            </Col>
                          );
                        })}
                      </Row>
                      </div>
                    </Col>
                  </Row>
                );
              })}
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

export default CandidateReviewModal;
